import { classifyClientError, type ApiErrorKind } from '@/services/apiError';

type Props = {
  message: string;
  /** 可选：覆盖 kind（默认从文案推断） */
  kind?: ApiErrorKind;
  id?: string;
  className?: string;
  /** 深色底上的浅色字（如 Hero 搜索区） */
  tone?: 'light' | 'dark';
};

/**
 * 业务失败统一提示（skill：role=alert 朗读；错误靠近操作点；可恢复文案由父级提供按钮）。
 */
export default function ApiErrorAlert({
  message,
  kind: kindProp,
  id,
  className = '',
  tone = 'light',
}: Props) {
  if (!message.trim()) return null;
  const kind = kindProp ?? classifyClientError(message);
  const icon =
    kind === 'offline'
      ? 'ri-cloud-off-line'
      : kind === 'timeout'
        ? 'ri-time-line'
        : 'ri-error-warning-line';

  const palette =
    tone === 'dark'
      ? 'border-accent-200/40 bg-accent-950/40 text-accent-100'
      : 'border-accent-200 bg-accent-50 text-accent-900';

  return (
    <p
      id={id}
      role="alert"
      aria-live="assertive"
      className={`rounded-md border px-3 py-2 text-left text-sm leading-relaxed ${palette} ${className}`.trim()}
    >
      <i className={`${icon} mr-1.5`} aria-hidden="true" />
      {message}
    </p>
  );
}
